import { useState } from "react";
import {
  Avatar,
  Box,
  Divider,
  Menu,
  MenuItem,
  Switch,
  Typography,
} from "@mui/material";
import {
  Logout as LogoutIcon,
  Slideshow as SlideshowIcon,
} from "@mui/icons-material";

export default function AccountMenu({
  user,
  signOut,
  presentationMode,
  onTogglePresentationMode,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleSignOut = () => {
    handleClose();
    signOut();
  };

  const styles = {
    trigger: {
      display: "flex",
      alignItems: "center",
      gap: 1,
      cursor: "pointer",
    },
    name: { mr: 0.5 },
    avatar: {
      width: 32,
      height: 32,
      bgcolor: "appBarAvatar.main",
      color: "appBarAvatar.contrastText",
    },
    menuPaper: { mt: 1, borderRadius: 2, minWidth: 200 },
    email: {
      color: "text.secondary",
      fontSize: "0.8125rem",
      opacity: 1,
      "&.Mui-disabled": { opacity: 1 },
    },
    presentationItem: { gap: 1.25, py: 1, justifyContent: "space-between" },
    presentationLabel: { display: "flex", alignItems: "center", gap: 1.25 },
    logoutItem: { gap: 1.25, py: 1 },
  };

  return (
    <>
      <Box
        sx={styles.trigger}
        onClick={handleOpen}
        role="button"
        aria-label="Account menu"
      >
        <Avatar sx={styles.avatar} />
        {user?.name && !presentationMode && (
          <Typography variant="body2" sx={styles.name}>
            {user.name}
          </Typography>
        )}
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { sx: styles.menuPaper } }}
      >
        {user?.username && [
          <MenuItem key="email" disabled sx={styles.email}>
            {user.username}
          </MenuItem>,
          <Divider key="divider" />,
        ]}
        <MenuItem
          onClick={onTogglePresentationMode}
          sx={styles.presentationItem}
        >
          <Box sx={styles.presentationLabel}>
            <SlideshowIcon fontSize="small" />
            Presentation mode
          </Box>
          <Switch
            size="small"
            checked={presentationMode}
            onChange={onTogglePresentationMode}
            onClick={(e) => e.stopPropagation()}
          />
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleSignOut} sx={styles.logoutItem}>
          <LogoutIcon fontSize="small" />
          Log out
        </MenuItem>
      </Menu>
    </>
  );
}
